import React from "react"

const ServerPagination = ({
  currentPage,
  pageSize,
  totalItems,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / pageSize)
  if (totalPages === 0) return null

  const pages = []

  const addPage = num => {
    pages.push({
      type: "page",
      num,
    })
  }

  const addDots = key => {
    pages.push({
      type: "dots",
      key,
    })
  }

  // Always show first page
  addPage(1)

  // Show left dots
  if (currentPage > 4) addDots("left")

  // Show numbers around current page
  const start = Math.max(2, currentPage - 1)
  const end = Math.min(totalPages - 1, currentPage + 1)

  for (let i = start; i <= end; i++) addPage(i)

  // Show right dots
  if (currentPage < totalPages - 3) addDots("right")

  // Always show last page
  if (totalPages > 1) addPage(totalPages)

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center flex-wrap py-3 py-md-0">
        {/* Showing Entries */}
        <p>
          Showing {(currentPage - 1) * pageSize + 1} to{" "}
          {Math.min(currentPage * pageSize, totalItems)} of {totalItems} entries
        </p>

        <ul className="pagination m-0">
          {/* Prev */}
          <li
            className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
            onClick={() => currentPage > 1 && onPageChange(currentPage - 1)}
          >
            <span className="page-link">Prev</span>
          </li>

          {/* Page numbers + dots */}
          {pages.map((item, index) => {
            if (item.type === "dots") {
              return (
                <li key={index} className="page-item disabled">
                  <span className="page-link">…</span>
                </li>
              )
            }

            return (
              <li
                key={index}
                className={`page-item ${
                  item.num === currentPage ? "active" : ""
                }`}
                onClick={() => onPageChange(item.num)}
              >
                <span
                  className={`page-link ${
                    item.num === currentPage ? "bg-purple text-white" : ""
                  }`}
                >
                  {item.num}
                </span>
              </li>
            )
          })}

          {/* Next */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
            onClick={() =>
              currentPage < totalPages && onPageChange(currentPage + 1)
            }
          >
            <span className="page-link">Next</span>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default ServerPagination
